import { PRODUCT_TOKEN } from '@rsos/sinatra/src/actions/types';
import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';

const baseURL = `${getAPIHost()}/what3words/v3`;

export const fetchWhat3words = (latitude, longitude) => {
  const token = localStorage.getItem(PRODUCT_TOKEN);
  return fetch(
    `${baseURL}/convert-to-3wa?coordinates=${latitude}%2C${longitude}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
    },
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(res => res);
};

export const fetchWhat3wordsLocation = w3w => {
  const token = localStorage.getItem(PRODUCT_TOKEN);
  return fetch(`${baseURL}/convert-to-coordinates?words=${w3w}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    credentials: 'same-origin',
  })
    .then(checkStatus)
    .then(parseJSON)
    .then(res => res);
};
